export default {
  computed: {
    userId () {
      return Number.parseInt(this.$route.params.id) || ''
    },
    fullUserName () {
      return this.user && this.user?.firstName && this.user?.lastName
        ? `${this.user?.firstName} ${this.user?.lastName}`
        : ''
    },
    userEmail () {
      return this.user && this.user?.email ? this.user?.email : ''
    },
    userPhoneAndPrefix () {
      return this.user && (this.user?.phonePrefix || this.user?.phone)
        ? `${this.user?.phonePrefix && this.user?.phonePrefix.phonePrefix
          ? this.user?.phonePrefix.phonePrefix
          : ''
        } - ${this.user?.phone ? this.user?.phone : ''}`
        : ''
    },
    userStatus () {
      return this.user && this.user?.status ? this.user?.status : false
    },
    userCreatedAt () {
      return this.user && this.user?.createdAt ? this.user?.createdAt : ''
    },
    userProfilePictureId () {
      return this.user && this.user?.profilePicture
        ? this.user?.profilePicture.id
        : false
    },

    userStatusClass () {
      if (
        this.userStatus &&
        ['INVITE_BY_SUPER_ADMIN', 'INVITE_BY_ADMIN'].includes(
          this.userStatus.statusType.code
        )
      ) {
        return 'status--pending'
      }
      if (this.userStatus && this.userStatus.statusType.code === 'ACTIVE') {
        return 'status--green'
      }
      if (this.userStatus && this.userStatus.statusType.code === 'ARCHIVE') {
        return 'status--expired'
      }
      return 'u-black'
    },
    cardStatus () {
      return this.user && this.user?.physicalCardStatus
        ? this.user?.physicalCardStatus
        : ''
    },
    cardStatusClass () {
      if (this.cardStatus === 'PENDING' || this.cardStatus === 'FROZEN') { return 'status--pending' }
      if (this.cardStatus === 'ACTIVE') return 'status--green'
      if (this.cardStatus === 'BLOCKED' || this.cardStatus === 'DISABLED') { return 'status--expired' }
      return 'u-black'
    },
    userIsActive () {
      return this.user && this.user?.status && this.user?.status?.statusType?.code === 'ACTIVE'
    },
    userGrossSalary () {
      return this.user && this.user?.grossSalary >= 0 ? this.user?.grossSalary : null
    },
    userIsCurrentLoggedUser () {
      return this.user.id === this.$store.getters['LoginStore/loggedUserId']
    }
  }
}
